import { defineMessages } from 'react-intl';

export default defineMessages({
  validate: {
    id: 'legal_proceeding_page.validation_buttons.validate',
  },
  validationJudgementAddMessage: {
    id: 'judgement_add_update.success',
  },
  validationAppealAddMessage: {
    id: 'appeal_add_document.success',
  },
  invoiceNumberField: {
    id: 'invoice.dialog_info.field_invoice_number',
  },
  invoiceDateField: {
    id: 'invoice.dialog_info.field_invoice_date',
  },
  invoiceReceptionDateField: {
    id: 'invoice.dialog_info.field_invoice_reception_date',
  },
});
